import { injectGlobal } from '@bd/bdui-styles/emotion';
import colors from './colors';

injectGlobal(`
  @media (min-width: 1600px) {
    .container {
      max-width: 1400px;
    }
  }
  @media (min-width: 1800px) {
    .container {
      max-width: 1600px;
    }
  }
  .btn {
    background-color: ${colors.brand2};
    color: ${colors.white};
    font-weight: 700;
    line-height: 1;
    text-transform: uppercase;
    letter-spacing: 2px;
    border-radius: 5px;
    border: 2px solid ${colors.brand2};
    padding: 10px 15px;
    font-size: 14px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    text-align: center;
    transition: all .3s ease;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: fit-content;
    box-shadow: 0 9px 12px rgba(0,0,0,0.1);
    @media (min-width: 992px) {
      padding: 20px 30px;
      font-size: 16px;
    }
    &:hover {
      color: ${colors.white};
      background-color: ${colors.brand2Darkest};
      border: 2px solid ${colors.brand2Darkest};
      box-shadow: 0 12px 15px rgba(0,0,0,0.2);
    }
  }
  .btn-small {
    background-color: ${colors.brand2};
    color: ${colors.white};
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    text-transform: uppercase;
    letter-spacing: 2px;
    border-radius: 5px;
    border: 2px solid ${colors.brand2};
    padding: 10px 15px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    text-align: center;
    transition: all .3s ease;
    &:hover {
      color: ${colors.white};
      background-color: ${colors.brand2Darkest};
      border: 2px solid ${colors.brand2Darkest};
    }
  }
  .btn-block-mobile {
    width: 100%;
    display: block;
    @media (min-width: 992px) {
      width: auto;
      display: inline-block;
    }
  }
  .btn-brand1 {
    background-color: ${colors.brand1};
    border: 2px solid ${colors.brand1};
    color: ${colors.brand1DarkestTextLarge};
    &:hover {
      color: ${colors.brand1DarkestTextLarge};
      background-color: ${colors.brand1Lighter};
      border: 2px solid ${colors.brand1Lighter};
    }
  }
  .btn-brand2 {
    background-color: ${colors.brand2};
    border: 2px solid ${colors.brand2};
    color: ${colors.brand2DarkestTextLarge};
    &:hover {
      color: ${colors.brand2DarkestTextLarge};
      background-color: ${colors.brand2Lighter};
      border: 2px solid ${colors.brand2Lighter};
    }
  }
  .btn-brand3 {
    background-color: ${colors.brand3};
    border: 2px solid ${colors.brand3};
    color: ${colors.white};
    &:hover {
      color: ${colors.white};
      background-color: ${colors.brand3Dark};
      border: 2px solid ${colors.brand3Dark};
    }
  }
  .btn-brand4 {
    background-color: ${colors.brand4};
    border: 2px solid ${colors.brand4};
    color: ${colors.brand4DarkestTextLarge};
    &:hover {
      color: ${colors.brand4DarkestTextLarge};
      background-color: ${colors.brand4Lighter};
      border: 2px solid ${colors.brand4Lighter};
    }
  }
  .btn-white {
    background-color: ${colors.white};
    border: 2px solid ${colors.white};
    background-image: none !important;
    color: ${colors.body};
    &:hover {
      color: ${colors.body} !important;
      background-color: ${colors.white} !important;
      border: 2px solid ${colors.brand3} !important;
    }
  }
  .btn-hollow {
    background-color: transparent;
    color: ${colors.body};
    border: 2px solid ${colors.body};
    background-image: none;
    &:hover {
      background-color: ${colors.brand1};
      border: 2px solid ${colors.white};
    }
  }
  .btn-hollow-white {
    background-color: transparent;
    color: ${colors.whiteDark};
    border: 2px solid ${colors.whiteDark};
    background-image: none;
    &:hover {
      background-color: ${colors.brand2};
      border: 2px solid ${colors.whiteDark};
    }
  }
  .btn-hollow-brand1 {
    background-color: transparent;
    color: ${colors.brand1};
    border: 2px solid ${colors.brand1};
    background-image: none;
    &:hover {
      background-color: ${colors.brand1};
      border: 2px solid ${colors.brand1};
      color: ${colors.white};
    }
  }
  .btn-hollow-brand2 {
    background-color: transparent;
    color: ${colors.brand2};
    border: 2px solid ${colors.brand2};
    background-image: none;
    &:hover {
      background-color: ${colors.brand2};
      border: 2px solid ${colors.brand2};
      color: ${colors.white};
    }
  }
  .btn-hollow-brand3 {
    background-color: transparent;
    color: ${colors.brand3};
    border: 2px solid ${colors.brand3};
    background-image: none;
    &:hover {
      background-color: ${colors.brand3};
      border: 2px solid ${colors.brand3};
      color: ${colors.white};
    }
  }
  .btn-hollow-brand4 {
    background-color: transparent;
    color: ${colors.brand4};
    border: 2px solid ${colors.brand4};
    background-image: none;
    &:hover {
      background-color: ${colors.brand4};
      border: 2px solid ${colors.brand4};
      color: ${colors.white};
    }
  }
  .btn-arrow-white {
    &::after {
      content: '';
      position: relative;
      width: 20px;
      height: 20px;
      margin: 0 0 0 7px;
      background-image: url('/images/icon-button-arrow-right-white.svg');
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      flex-shrink: 0;
    }
  }
  .btn-arrow-black {
    &::after {
      content: '';
      position: relative;
      width: 20px;
      height: 20px;
      margin: 0 0 0 7px;
      background-image: url('/images/icon-button-arrow-right.svg');
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      flex-shrink: 0;
    }
    &:hover {
      &::after {
        background-image: url('/images/icon-button-arrow-right.svg');
      }
    }
  }
  .btn-arrow-orange {
    &::after {
      content: '';
      position: relative;
      width: 20px;
      height: 20px;
      margin: 0 0 0 7px;
      background-image: url('/images/icon-button-arrow-right-orange.svg');
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      flex-shrink: 0;
    }
  }
  .btn-phone-white {
    &::before {
      content: '';
      position: relative;
      width: 22px;
      height: 22px;
      margin: 0 5px 0 0;
      background-image: url('/images/icon-phone-white.svg');
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      flex-shrink: 0;
    }
  }
  .btn-phone-black {
    &::before {
      content: '';
      position: relative;
      width: 22px;
      height: 22px;
      margin: 0 5px 0 0;
      background-image: url('/images/icon-phone.svg');
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      flex-shrink: 0;
    }
    &:hover {
      &::after {
        background-image: url('/images/icon-phone-white.svg');
      }
    }
  }
  .btn-chat-white {
    &::before {
      content: '';
      position: absolute;
      position: relative;
      width: 22px;
      height: 22px;
      margin: 0 10px 0 0;
      background-image: url('/images/icon-chat-white.svg');
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      flex-shrink: 0;
    }
  }
  .btn-chat-black {
    &::before {
      content: '';
      position: relative;
      width: 22px;
      height: 22px;
      margin: 0 5px 0 0;
      background-image: url('/images/icon-chat.svg');
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      flex-shrink: 0;
    }
    &:hover {
      &::after {
        background-image: url('/images/icon-chat-white.svg');
      }
    }
  }
  .btn-download-white {
    &::before {
      content: '';
      position: relative;
      width: 22px;
      height: 22px;
      margin: 0 5px 0 0;
      background-image: url('/images/icon-download-white.svg');
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      flex-shrink: 0;
    }
  }
  .btn-download-black {
    &::before {
      content: '';
      position: relative;
      width: 22px;
      height: 22px;
      margin: 0 5px 0 0;
      background-image: url('/images/icon-download.svg');
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      flex-shrink: 0;
    }
    &:hover {
      &::after {
        background-image: url('/images/icon-download-white.svg');
      }
    }
  }

  .badge {
    background-color: ${colors.brand1};
    color: ${colors.white};
    padding: 4px 6px;
    margin: 0 4px;
  }

  .tab {
    padding: 6px 0;
    color: ${colors.body};
    font-weight: 600;
    line-height: 1;
    text-transform: uppercase;
    letter-spacing: 0;
    border-radius: 0;
    border: 0;
    font-size: 12px;
    margin: 0 8px;
    background-color: transparent;
    border-bottom: 4px solid transparent;
    &.active {
      border-bottom: 4px solid ${colors.brand3};
      outline-color: ${colors.white};
      &:focus {
        animation: focus-fade 4s ease;
        outline-color: ${colors.white};
      }
    }
    @media (min-width: 992px) {
      margin: 0 15px;
      font-size: 16px;
    }
  }
  @keyframes focus-fade {
   0% {outline-color: -webkit-focus-ring-color;}
   50% {outline-color: -webkit-focus-ring-color;}
   100% {outline-color: ${colors.white}}
  }
  .close {
    float: none;
  }
  body.modal-mode .modal-close {
    border-radius: 40px;
    position: relative !important;
    top: 0 !important;
    width: fit-content !important;
    margin: 10px !important;
  }
  .animate__animated {
    --animate-delay: 0.5s;
  }
  
  /* controls size of video and tour images inside of lightbox in Carousel_Elliott */
  .ril-image-current {
    .Carousel_imageElement {
      position: relative;
      width: 80%;
      padding-top: calc(80% * 0.5625);
      margin-top: -22%;
      top: 50%;
      margin-left: 10%;
    }
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`);



// WEBPACK FOOTER //
// ./src/styles/reset.js